<template>
    <div
        class="flex flex-col items-end gap-2"
    >
        <div
            class="inline-block origin-bottom-right rounded-2xl border border-white/60 bg-slate-100/70 p-2 pb-0 shadow-md backdrop-blur-md transition-all"
            :class="{
                'delay-100 ease-in-out duration-300': open,
                'scale-[.98] opacity-0 translate-y-4 ease-in duration-150':
                    !open,
            }"
        >
            <div
                class="max-w-[240px] rounded-lg bg-white px-4 py-8 shadow sm:p-8"
            >
                <div class="mb-1 flex gap-2">
                    <h2
                        class="text-base font-bold"
                        id="vx-pop-up__title"
                    >
                        Keep in Touch
                    </h2>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="24"
                        viewBox="0 0 512 512"
                        class="self-start"
                    >
                    <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                    <path d="M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"/>
                    </svg>
                </div>
                <p class="mb-4 text-xs text-slate-500">
                    Would you like to receive special offers via text?
                </p>
                <form>
                    <label class="mb-2 block">
                        <span
                            class="block text-xs font-semibold text-slate-700"
                        >
                            First Name *
                        </span>
                        <input
                            type="text"
                            class="mt-1 appearance-none block w-full rounded-sm border border-solid border-slate-300 bg-white px-3 py-2 text-base invalid:border-rose-500 invalid:text-rose-600 focus:border-sky-500 focus:outline-hidden focus:ring-1 focus:ring-sky-500 focus:invalid:border-rose-500 focus:invalid:ring-rose-500 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500"
                        />
                    </label>

                    <label class="mb-4 block">
                        <span
                            class="block text-xs font-semibold text-slate-700"
                        >
                            Phone Number *
                        </span>
                        <input
                            type="text"
                            class="mt-1 appearance-none block w-full rounded-sm border border-solid border-slate-300 bg-white px-3 py-2 text-base invalid:border-rose-500 invalid:text-rose-600 focus:border-sky-500 focus:outline-hidden focus:ring-1 focus:ring-sky-500 focus:invalid:border-rose-500 focus:invalid:ring-rose-500 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500"
                        />
                    </label>

                    <button
                        role="button"
                        @click="prevent"
                        class="font-sans h-10 w-full rounded-md bg-slate-800 text-xs text-white transition hover:bg-slate-600 active:scale-95 active:opacity-80 disabled:scale-100 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-slate-800"
                    >
                        Sign Up
                    </button>
                </form>
            </div>
            <div
                class="translate-y-[-2%] py-2 text-center font-sans text-xs text-slate-600"
            >
                Powered by <span class="font-bold">Voxie</span>
            </div>
        </div>

        <button
            class="group relative h-14 w-14 cursor-pointer overflow-hidden rounded-2xl border text-white shadow-md backdrop-blur-md transition-all duration-300 active:scale-95 active:opacity-80"
            @click="open = !open"
            :class="{
                'border-slate-800 bg-slate-800': open,
                'bg-slate-100/70 border-white/60': !open,
            }"
        >
            <svg
                width="24"
                height="28"
                viewBox="0 0 24 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="absolute left-1/2 top-1/2 mt-[2px] -translate-x-1/2 -translate-y-1/2 fill-slate-800 transition-all duration-300 group-hover:fill-slate-600 group-active:fill-slate-800"
                :class="{
'scale-[3]': open
                }"
            >
                <path
                    d="M18.6953 0.981445H5.3076C4.61052 0.981445 3.92027 1.12142 3.27626 1.39339C2.63225 1.66535 2.04711 2.06398 1.55424 2.5665C1.06137 3.06901 0.670436 3.66558 0.403757 4.32213C0.137078 4.97868 -0.00011896 5.68235 7.73939e-08 6.39295V18.1556C7.73939e-08 19.5906 0.559192 20.9668 1.55456 21.9815C2.54993 22.9962 3.89994 23.5662 5.3076 23.5662V27.0993L9.8294 23.5662H18.6926C20.1003 23.5662 21.4503 22.9962 22.4457 21.9815C23.441 20.9668 24.0002 19.5906 24.0002 18.1556V6.39295C24.0005 4.9583 23.4418 3.58228 22.4469 2.56748C21.4521 1.55267 20.1027 0.98218 18.6953 0.981445Z"
                ></path>
            </svg>

            <span
                class="font-thin text-2xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all"
                :class="{ 'opacity-0': !open }"
            >&times;</span>
        </button>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const open = ref(true);
</script>
